export const setLocalStorageValue = (key: string, value: string): void => localStorage.setItem(key, value);
export const getLocalStorageValue = (key: string): string | null => localStorage.getItem(key);
